import React from 'react';

import {
  ACCESS_ROLES_FOR_CAMPAIGNS,
  ACCESS_ROLES_FOR_GRAPHICS_STATISTICS,
  ACCESS_ROLES_FOR_MAP,
  ACCESS_ROLES_FOR_MODERATION,
  ACCESS_ROLES_FOR_REPORTS,
  ACCESS_ROLES_FOR_STATISTICS,
} from '@/api/routes/users/constants';
import { ROLES } from '@/api/routes/users/types';
import Assignment from '@/assets/images/icons/assignment.svg';
import Chart from '@/assets/images/icons/bar-chart.svg';
import ListAlt from '@/assets/images/icons/list-alt.svg';
import Loyalty from '@/assets/images/icons/loyalty.svg';
import Map from '@/assets/images/icons/map.svg';
import Reports from '@/assets/images/icons/reports.svg';
import SelectAll from '@/assets/images/icons/select-all.svg';
import Settings from '@/assets/images/icons/settings.svg';
import Users from '@/assets/images/icons/supervisor_account.svg';
import Timeline from '@/assets/images/icons/timeline.svg';
import Warning from '@/assets/images/icons/warning.svg';

interface IRoute {
  route: string,
  icon: React.ReactNode,
  lngKey: string,
  roles: ROLES [],
  noExport?: boolean,
  additionalRequiredRoles?: ROLES [],
}

const routeArray: IRoute [] = [
  {
    route: 'moderation?adminModState=1&campType=oncar',
    icon: <Loyalty />,
    lngKey: 'components.NavBar.moderation',
    roles: ACCESS_ROLES_FOR_MODERATION,
  },
  {
    route: 'campaigns',
    icon: <SelectAll />,
    lngKey: 'components.NavBar.campaigns',
    roles: ACCESS_ROLES_FOR_CAMPAIGNS,
  },
  {
    route: 'map?onlineStatus=online',
    icon: <Map />,
    lngKey: 'components.NavBar.map',
    roles: ACCESS_ROLES_FOR_MAP,
  },
  {
    route: 'table?sortBySumm=connection_off_secs%2Cgps_off_secs%2Cpause_secs%2Clost_secs&sortOrder=desc',
    icon: <ListAlt />,
    lngKey: 'components.NavBar.table',
    roles: [ROLES.STAT_VIEW, ROLES.VIEW, ROLES.STAT_DEVICE_PROFILE_VIEW],
  },
  {
    route: 'graphics',
    icon: <Timeline />,
    lngKey: 'components.NavBar.graphics',
    roles: ACCESS_ROLES_FOR_GRAPHICS_STATISTICS,
  },
  {
    route: 'incidents',
    icon: <Warning />,
    lngKey: 'components.NavBar.incidents',
    roles: [ROLES.INCIDENT_VIEW, ROLES.VIEW],
  },
  {
    route: 'views',
    icon: <Chart />,
    lngKey: 'components.NavBar.views',
    roles: ACCESS_ROLES_FOR_STATISTICS,
  },
  {
    route: 'reports',
    icon: <Reports />,
    lngKey: 'components.NavBar.reports',
    roles: ACCESS_ROLES_FOR_REPORTS,
  },
  {
    route: 'users',
    icon: <Users />,
    lngKey: 'components.NavBar.users',
    roles: [ROLES.VIEW],
  },
  {
    route: 'profiles',
    icon: <Assignment />,
    lngKey: 'components.NavBar.profiles',
    roles: [ROLES.VIEW],
    additionalRequiredRoles: [ROLES.PROFILE_VIEW, ROLES.PROFILE_EDIT],
  },
  {
    route: 'settings',
    icon: <Settings />,
    lngKey: 'components.NavBar.settings',
    roles: [ROLES.VIEW],
  },
];

export default routeArray;
